class UgcLightbox extends HTMLElement {
  constructor() {
    super();
    this.stage = this.querySelector('[data-ugc-stage]');
    this.closeButtons = this.querySelectorAll('[data-ugc-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));
    this.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });
  }

  open(template, trigger) {
    this.trigger = trigger;
    this.stage.innerHTML = '';
    this.stage.appendChild(template.content.cloneNode(true));
    this.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');

    const video = this.stage.querySelector('video');
    if (video) {
      video.play().catch(() => {
        // Most mobile browsers (notably iOS Safari) block autoplay with sound.
        // Muted autoplay is allowed everywhere, so fall back to that rather than
        // leaving the video frozen with no feedback — native controls let the
        // visitor unmute with one tap.
        video.muted = true;
        video.play().catch(() => {});
      });

      // On phones, tapping a playing video (or its native fullscreen control)
      // can push it into the OS's own fullscreen player, which renders on top
      // of our ✕ button — leaving it tappable but invisible underneath. Closing
      // automatically the moment fullscreen ends keeps the ✕ (and backdrop tap,
      // and swipe-down-to-dismiss on iOS) working no matter how the visitor got
      // out of fullscreen.
      video.addEventListener('webkitendfullscreen', () => this.close());
    }

    trapFocus(this, this.querySelector('[data-ugc-close]'));
  }

  close() {
    if (this.hasAttribute('hidden')) return;

    const video = this.stage.querySelector('video');
    if (video) {
      video.pause();
      if (video.webkitDisplayingFullscreen && video.webkitExitFullscreen) video.webkitExitFullscreen();
    }
    if (document.fullscreenElement) document.exitFullscreen().catch(() => {});

    this.stage.innerHTML = '';
    this.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.trigger);
  }
}

customElements.define('ugc-lightbox', UgcLightbox);

document.querySelectorAll('[data-ugc-play]').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const template = document.getElementById(trigger.dataset.videoTarget);
    const lightbox = trigger.closest('.zv-ugc').querySelector('ugc-lightbox');
    if (template && lightbox) lightbox.open(template, trigger);
  });
});
